/**
 * @module popupBanner
 */

module.exports = function() {
    const popupBanner = document.getElementById( 'popup-banner' );

    const btnUpcoming = document.getElementById( 'buttonPopupTemplate' );
    const closeIcons = popupBanner.querySelectorAll( '.close' );
    const popupAnimation = popupBanner.querySelector( '.popup-animation' );
    const popupMobile = popupBanner.querySelector( '.popup-mobile' );

    const scrollShow = Number( popupBanner.getAttribute( 'data-scroll-show' ) );
    const timerShow = Number( popupBanner.getAttribute( 'data-timer-show' ) );
    const cookieName = popupBanner.getAttribute( 'data-cookie-name' );
    const cookieTime = Number( popupBanner.getAttribute( 'data-cookie-time' ) );
    const heightForShow = ( document.body.offsetHeight - window.innerHeight ) * ( scrollShow / 100 );

    function hidePopup( popupType ) {
        if ( popupType === 'animation' ) {
            popupAnimation.classList.remove( 'd-xl-block' );
        } else if ( popupType === 'mobile' ) {
            popupMobile.classList.remove( 'd-xl-none', 'd-block' );
            popupMobile.classList.add( 'd-none' );
        } else {
            popupBanner.classList.add( 'd-none' );
        }
        document.cookie = `${ cookieName }=false; path=/; max-age=${ cookieTime };`;
    }

    window.addEventListener( 'load', () => {
        if ( scrollShow === 0 ) {
            setTimeout( () => {
                popupBanner.classList.remove( 'd-none' );
            }, timerShow );
        }
    } );

    if ( scrollShow ) {
        window.addEventListener( 'scroll', () => {
            if ( window.scrollY > heightForShow ) {
                popupBanner.classList.remove( 'd-none' );
            }
        } );
    }

    closeIcons.forEach( ( closeIcon ) => {
        closeIcon.addEventListener( 'click', ( event ) => {
            if ( event.target.closest( '.popup-animation' ) ) {
                hidePopup( 'animation' );
            } else if ( event.target.closest( '.popup-mobile' ) ) {
                hidePopup( 'mobile' );
            } else {
                hidePopup();
            }
        } );
    } );

    if ( btnUpcoming ) {
        btnUpcoming.addEventListener( 'click', () => {
            hidePopup( 'animation' );
        } );
    }

    document.addEventListener( 'click', ( event ) => {
        if (
            popupAnimation &&
            popupAnimation.classList.contains( 'd-xl-block' ) &&
            ! popupAnimation.contains( event.target )
        ) {
            hidePopup( 'animation' );
        }
    } );

    if ( popupMobile ) {
        popupMobile.addEventListener( 'click', ( event ) => {
            const isCloseIcon = event.target.closest( '.close' );
            const isButton = event.target.closest( '.btn' );
            if ( isCloseIcon || isButton ) {
                hidePopup( 'mobile' );
            }
        } );
    }
};
